import React from 'react';
import { Grid } from 'semantic-ui-react';
import CohortVisibilityChanger from '../containers/CohortVisibilityChanger';

const CohortVisibilityChangerRow = ({ category, code }) => (
  <Grid.Row>
    <Grid.Column>
      <CohortVisibilityChanger code={code} category={category} />
    </Grid.Column>
  </Grid.Row>
);

export default CohortVisibilityChangerRow;
